module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-7-19b138e23e43ce4f507ad759e8ffc258.jpg";